import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { SELLER_AREAS } from '../../constants/sellerAreas';

// Seller-intent section: links every neighborhood valuation page (SEO internal linking + conversion).
export const SellerAreasSection = () => (
  <section id="sell" className="py-20 bg-[#143160] text-white relative overflow-hidden" data-testid="seller-areas-section">
    <div className="absolute inset-0 opacity-[0.07] bg-[radial-gradient(circle_at_80%_20%,#BFA26A,transparent_40%)]"></div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 items-center">
        <div className="space-y-6">
          <p className="text-gold-300 font-bold tracking-[0.25em] text-xs uppercase flex items-center gap-2"><TrendingUp className="w-4 h-4" />Thinking of Selling?</p>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight">What's Your Coastal Home Worth?</h2>
          <p className="text-white/80 text-lg leading-relaxed">Virginia Beach and Outer Banks home values have shifted this year. Get a free, no-pressure home value report built from real neighborhood sales — no strings, just the number.</p>
          <Link to="/home-value" data-testid="seller-section-cta" className="inline-flex items-center bg-gold-500 hover:bg-gold-400 text-[#143160] font-black px-7 py-4 rounded-md uppercase tracking-wide transition-colors">Get My Free Home Value <ArrowRight className="w-5 h-5 ml-2" /></Link>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {SELLER_AREAS.map((a) => (
            <Link key={a.slug} to={`/sell/${a.slug}`} data-testid={`seller-area-${a.slug}`} className="group flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 hover:border-gold-400/60 rounded-xl px-5 py-4 transition-colors">
              <div>
                <p className="font-bold">{a.name}</p>
                <p className="text-xs text-white/55">{a.region}, {a.state}</p>
              </div>
              <ArrowRight className="w-4 h-4 text-gold-400 group-hover:translate-x-1 transition-transform" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  </section>
);
